
<template>
  <div id="leftSide">
    <div class="logo">
      <simple-svg
          :filepath="iconSrc"
          :fill="'#FFF'"
          height="100"
          class="icon"
      />
      <hr class="line"/>
    </div>
    <p>Communicate in Harmony</p>
  </div>
</template>

<script>

export default {
  name: 'LeftSide',
  data () {
    return {
    }
  },
  computed: {
    iconSrc () {
      return require('../assets/maestro.svg')
    }
  }
}
</script>
